import { render } from "./ParamFarm.vue?vue&type=template&id=7638ad22&scoped=true"
import script from "./ParamFarm.vue?vue&type=script&lang=js"
export * from "./ParamFarm.vue?vue&type=script&lang=js"

import "./ParamFarm.vue?vue&type=style&index=0&id=7638ad22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7638ad22"]])

export default __exports__